<template>
  <div class="custom-progress-bar">
    <div class="progress-box">
      <div class="active-progress-line" :style="{width: `${percent}%`}"></div>
    </div>
    <div v-if="showPercent" class="percent-text">{{ percent }} %</div>
  </div>
</template>

<script>
export default {
  name: "customProgressBar",
  props: {
    percent: {
      type: Number,
      default: 0
    },
    showPercent: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vuexy/_variables.scss";

.custom-progress-bar {
  width: 100%;

  .progress-box {
    position: relative;
    background-color: #e9e9e9;
    height: 10px;
    border-radius: 0.5rem;

    .active-progress-line {
      position: absolute;
      left: 0;
      height: 100%;
      border-radius: 0.5rem;
      background-color: $primary;
      transition: width ease 0.3s;
    }
  }

  .percent-text {
    line-height: 20px;
  }
}
</style>
